import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

export interface IBulkRejectModeratedContentItem {
  contentType?: "Photo" | "Video"
  contentId?: number
}

export interface IBulkRejectModeratedRequest {
  contents?: IBulkRejectModeratedContentItem[]
  notes?: string
}

interface IUseRejectModeratedMediaArgs {
  eventVaultId: number
  requestBody: IBulkRejectModeratedRequest
}

export async function rejectModeratedMedia(requestBody: IBulkRejectModeratedRequest, eventVaultId: number) {
  await v1.patch(`/${eventVaultId}/moderate/bulk-reject`, requestBody)
}

export const REJECT_MODERATED_MEDIA = "rejectModeratedMedia"

export function useRejectModeratedMedia() {
  return useMutation({
    mutationKey: [REJECT_MODERATED_MEDIA],
    mutationFn: ({ eventVaultId, requestBody }: IUseRejectModeratedMediaArgs) =>
      rejectModeratedMedia(requestBody, eventVaultId),
  })
}
